import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getHideSelfView } from '../../../base/settings/functions.any';
import { getCurrentLayout } from '../../../video-layout/functions.any';
import { setVisibleRemoteParticipants } from '../../actions.any';
import { LAYOUTS } from '../../../video-layout/constants';
const GridTileView = () => {
    const dispatch = useDispatch();
    const { remoteParticipants, tileViewMode, newParticipantJoinID, newParticipantLeaveID, isPaging, width, topPanelHeight, verticalViewDimensions } = useSelector((state) => state['features/filmstrip']);
    const { localScreenShare } = useSelector((state) => state['features/base/participants']);
    const currentLayout = useSelector((state) => getCurrentLayout(state));
    const disableSelfView = useSelector((state) => getHideSelfView(state));
    const localParticipantsCount = localScreenShare ? 2 : 1;
    let participantPage = tileViewMode - (disableSelfView ? 0 : localParticipantsCount);
    useEffect(() => {
        if (currentLayout !== LAYOUTS.VERTICAL_FILMSTRIP_VIEW || verticalViewDimensions.gridView?.gridDimensions) {
            const end = disableSelfView ? Math.min(remoteParticipants.length, tileViewMode - 2) : Math.min(participantPage - 2, remoteParticipants.length - 1);
            dispatch(setVisibleRemoteParticipants(0, end));
        }
    }, [tileViewMode, currentLayout, newParticipantJoinID, newParticipantLeaveID, isPaging, width, topPanelHeight, localScreenShare, disableSelfView, remoteParticipants.length]);
    return (React.createElement(React.Fragment, null));
};
export default GridTileView;
